import Link from 'next/link';

import './BlockLink.scss';

export default function BlockLink({ link, title, imageUrl }) {
  return (
    <Link href={link}>
      <div className="blockLink cursor-pointer">
        <img className="blockLink-img" alt={title} src={imageUrl} />

        <p className="blockLink-title">{title}</p>
      </div>
    </Link>
  );
}
